import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Language } from 'src/app/shared/models/language';

@Injectable({
  providedIn: 'root'
})
export class TranslationService implements OnInit {

  subject: BehaviorSubject<any> | undefined;
  translate_object: any = {};
  languages: Language[] | undefined;
  selected_language: Language = new Language({});

  constructor(private http: HttpClient) {
    this.use(this.selected_language.value!);
  }

  ngOnInit() {
  }

  use(languages: string): Promise<{}> {
    return new Promise<{}>((resolve, reject) => {
      const langPath = "./assets/" + `i18n/${languages}.json?`;
      this.http.get(langPath).subscribe(
        translation => {
          this.translate_object = translation;
          resolve(this.translate_object);
        },
        error => {
          this.translate_object = {};
          resolve(this.translate_object);
        }
      );
    });
  }

  getText(language_key: string): string {
    try {
      const text = this.translate_object[language_key];
      return text !== undefined && text !== null && text !== '' ? text : language_key;
    } catch (err) {
      return language_key;
    }
  }
}
